import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export const usePageMetadata = (pageSlug) => {
  const [metadata, setMetadata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pageSlug) return;

    const fetchMetadata = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log(`🔍 Fetching page metadata for: ${pageSlug}`);
        const { data, error: fetchError } = await supabase
          .from('page_metadata')
          .select('id, page_slug, title_en, title_ar, description_en, description_ar, last_updated')
          .eq('page_slug', pageSlug)
          .maybeSingle();

        console.log(`📊 Page metadata response for ${pageSlug}:`, { data, error: fetchError });

        if (fetchError) {
          console.error(`❌ Page metadata fetch error for ${pageSlug}:`, fetchError);
          throw fetchError;
        }

        console.log(`✅ Loaded page metadata for ${pageSlug}:`, data ? 'Found' : 'Not found');
        setMetadata(data ?? null);
      } catch (err) {
        console.error(`❌ Error fetching page metadata for ${pageSlug}:`, err);
        setError(err.message || 'Failed to load page metadata');
        setMetadata(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [pageSlug]);

  return { metadata, loading, error };
};

